module.exports = __webpack_public_path__ + "assets/img/00117.8ecf5d8a.png";